import { Grid } from "@mui/material";
import wlv from "./img-water-view.png"
import Iframe from 'react-iframe'
import MultiLineChart from "../../../Components/Chart/Component/MultiLineChart";
import { BOXGROUP_ID, ID_GROUPS } from "../../../../Utils/const";
import { useEffect, useState } from "react";
import sharedService from "../../../../Services/SharedService";
import { ONE_DAY, StartOf } from "../../../../Utils/time";
import WaterLevelView from "../../../Components/Chart/Component/WaterLevelView";
import { interpolateDrainBR, newInterpolateDrainBR, interpolateSR } from "../../../Components/Chart/Component/interplationBR";
import LineChart from "../../../Components/Chart/Component/LineChart";

const DashBoardBR = ({ boxs }) => {
    const [chartDR, setChartDR] = useState(null)
    const [chartWA, setChartWA] = useState(null)
    const [WAU, setWAU] = useState(null)

    function getLast24HourMarks() {
        const now = new Date();

        // làm tròn về đầu giờ hiện tại
        now.setMinutes(0, 0, 0);

        const hours = [];
        for (let i = 0; i < 24; i++) {
            hours.push(Math.floor(now.getTime() / 1000));
            now.setHours(now.getHours() - 1);
        }

        return hours.reverse(); // array timestamp (seconds)
    }

    function getFallbackWADRecords(count = 24) {
        const currentHour = new Date();
        currentHour.setMinutes(0, 0, 0);

        const records = [];
        for (let i = 0; i < count; i++) {
            records.push({
                WAD: 1.4,
                t: Math.floor(currentHour.getTime() / 1000)
            });
            currentHour.setHours(currentHour.getHours() - 1);
        }

        return records;
    }

    useEffect(() => {
        const time = {
            start: StartOf.Day(Date.now() - ONE_DAY),
            end: Date.now()

        }
        const rawLabels = getLast24HourMarks()
        const labels = rawLabels.map(r => r * 1000)
        const dataChartDR = {
            type: "multiLine",
            datasets: [
                {
                    label: "Độ mở cống",
                    code: "DR1",
                    backgroundColor: "rgb(255, 99, 132)",
                    borderColor: "rgb(255, 99, 132)",
                    data: []
                }
            ],
            labels,
            metric: 'DR',
        }

        const dataChartWA = {
            type: "line",
            datasets: [
            ],
            labels,
            metric: 'WA',
        }

        sharedService.listRecordBoxGroupByTime(time).then(res => {
            const result = res.data
            const boxWAU = result.find(r => r.metrics.includes('WAU'))
            let WAU = 0
            if (boxWAU.count > 0) {
                const recordHasWAU = boxWAU.records.find(r => r.WAU > 0)
                WAU = recordHasWAU ? recordHasWAU.WAU : 0
                setWAU(BOXGROUP_ID === ID_GROUPS.KL ? +recordHasWAU.WAU : BOXGROUP_ID === ID_GROUPS.SC ? 74.507 : recordHasWAU.WAU)
            }
            const boxDR = result.find(r => r.metrics.includes('DR1'))

            if (BOXGROUP_ID === ID_GROUPS.SR) {
                dataChartDR.datasets.push({
                    yAxisID: "y1",
                    label: "Lưu lượng qua cống",
                    code: "QS",
                    backgroundColor: "rgb(76 192 192)",
                    borderColor: "rgb(76 192 192)",
                    data: []
                })
                dataChartWA.datasets.push({
                    label: "Mực nước hạ lưu",
                    code: "WAD",
                    backgroundColor: "rgb(255, 99, 132)",
                    borderColor: "rgb(255, 99, 132)",
                    data: []
                })
                dataChartWA.datasets.push({
                    label: "Mực nước kênh",
                    code: "WAU",
                    backgroundColor: "rgb(76 192 192)",
                    borderColor: "rgb(76 192 192)",
                    data: []
                })

                const boxWAU = result.find(r => r.metrics.includes('WAU'))
                const boxWAD = result.find(r => r.metrics.includes('WAD'))

                const wadRecords = boxWAD?.records?.length > 0
                    ? boxWAD.records
                    : getFallbackWADRecords(24)

                labels.forEach(l => {
                    const currentLabel = new Date(l)
                    const recordWAD = wadRecords.find(r => {
                        const currentTime = new Date(r.t * 1000)
                        if (currentLabel.getDate() === currentTime.getDate() && currentLabel.getHours() === currentTime.getHours()) return r
                    })
                    if (recordWAD) dataChartWA.datasets[0].data.push(recordWAD.WAD)
                    else dataChartWA.datasets[0].data.push(0)

                    const recordWAU = boxWAU.records.find(r => {
                        const currentTime = new Date(r.t * 1000)
                        if (currentLabel.getDate() === currentTime.getDate() && currentLabel.getHours() === currentTime.getHours()) return r
                    })
                    if (recordWAU) dataChartWA.datasets[1].data.push(recordWAU.WAU)
                    else dataChartWA.datasets[1].data.push(0)
                })
            } else {
                dataChartDR.datasets.push({
                    yAxisID: "y1",
                    label: "Lưu lượng qua cống",
                    code: "QS",
                    backgroundColor: "rgb(76 192 192)",
                    borderColor: "rgb(76 192 192)",
                    data: []
                })
            }

            labels.map(l => {
                const currentLabel = new Date(l)
                const record = boxDR.records.find(r => {
                    const currentTime = new Date(r.t * 1000)
                    if (currentLabel.getDate() === currentTime.getDate() && currentLabel.getHours() === currentTime.getHours()) return r
                })
                if (record && record.DR1 > 0) {
                    if (ID_GROUPS.SR === BOXGROUP_ID) {
                        const interpol = interpolateSR(record.DR1, WAU)
                        dataChartDR.datasets[0].data.push(record.DR1)
                        dataChartDR.datasets[1].data.push(interpol)
                    } else {
                        const interpol = newInterpolateDrainBR(record.DR1, WAU)
                        dataChartDR.datasets[0].data.push(record.DR1)
                        dataChartDR.datasets[1].data.push(interpol)
                    }
                } else {
                    dataChartDR.datasets[0].data.push(0)
                    dataChartDR.datasets[1].data.push(0)

                }
            })

            setChartDR({ ...dataChartDR })
            setChartWA({ ...dataChartWA })
        })
    }, [boxs])

    return <>
        {BOXGROUP_ID === ID_GROUPS.SR ?
            <Grid container columns={12} className="DashBoardBR">
                <Grid
                    item
                    xs={12}
                    lg={5}
                    sx={{
                        marginTop: { xs: '50px', lg: '0px' }
                    }}

                >
                    <div className="list">
                        <div style={{ paddingRight: '20px' }} className="chart-container">
                            <p>Biểu đồ dữ liệu mực nước</p>
                            {chartWA && <LineChart data={chartWA} min={0} max={10} />}
                        </div>
                        <div className="chart-container">
                            <p>Biểu đồ dữ liệu đo mở cống</p>
                            <div className="chart-item">
                                {chartDR && <MultiLineChart height='100%' data={chartDR} max={390} />}
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={3.5}
                    sx={{
                        display: { xs: 'block', lg: 'block' }
                    }}>
                    <div className="cam">
                        <Iframe url="https://cam.dulieuthuyloivietnam.vn/stream/baria/101"
                            width="100%"
                            height="100%"
                            id=""
                            className=""
                            display="block"
                            position="relative" />
                    </div>
                    <div className="cam">
                        <Iframe url="https://cam.dulieuthuyloivietnam.vn/stream/baria/201"
                            width="100%"
                            height="100%"
                            id=""
                            className=""
                            display="block"
                            position="relative" />
                    </div>
                </Grid>
                <Grid item xs={12} lg={3.5} sx={{ maxWidth: '1000px', minWidth: '260px', width: '200px', marginTop: { xs: '20px', lg: '0px' } }}>
                    <div className="cam">
                        <Iframe url="https://cam.dulieuthuyloivietnam.vn/stream/baria/301"
                            width="100%"
                            height="100%"
                            id=""
                            className=""
                            display="block"
                            position="relative" />
                    </div>
                    <div className="cam">
                        <Iframe url="https://cam.dulieuthuyloivietnam.vn/stream/baria/401"
                            width="100%"
                            height="100%"
                            id=""
                            className=""
                            display="block"
                            position="relative" />
                    </div>
                </Grid>
            </Grid>
            :
            <Grid container columns={12} className="DashBoardBR">
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{
                        marginTop: { xs: '50px', lg: '0px' }
                    }}
                >
                    <div className="list2">
                        <div className="water-section">
                            <WaterLevelView WAU={WAU} />
                        </div>
                    </div>
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{
                        marginTop: { xs: '50px', lg: '0px' }
                    }}

                >
                    <div className="list2">
                        <div className="chart-container">
                            <div className="chart-item">
                                <p>Biểu đồ dữ liệu đo mở cống</p>
                                {chartDR && <MultiLineChart height='100%' data={chartDR} max={390} />}
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        }
    </>
}


export default DashBoardBR